import type { UserCalifornianStatus } from './user-californian-statuses.model';

export interface GenerateUserCalifornianStatusesOptions {
  readonly userIds: readonly number[];
  readonly isUserCalifornian?: boolean;
  readonly isUserPotentiallyCalifornian?: boolean;
}

export function generateUserCalifornianStatusObjects({
  userIds,
  isUserCalifornian = false,
  isUserPotentiallyCalifornian = false,
}: GenerateUserCalifornianStatusesOptions): readonly UserCalifornianStatus[] {
  return userIds.map(id => ({
    id: id.toString(),
    ip: '204.236.225.72',
    isUserPotentiallyCalifornian,
    isUserCalifornian,
  }));
}
